export const grey = {
  700: "#3f3f46",
};

export const red = "#EB5757";
export const blue = "#2F80ED";
